export default "__VITE_ASSET__D9gABwjr__"